import { Breadcrumb } from 'antd';
import { HomeOutlined, TeamOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const MemberPageBreadCrumb = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Breadcrumb
      items={[
        {
          onClick: () => {
            navigate('/');
          },
          title: (
            <span style={{ cursor: 'pointer' }}>
              <HomeOutlined style={{ marginRight: 4 }} />
              <span>{t('breadcrumb.admin')}</span>
            </span>
          ),
        },
        {
          title: (
            <>
              <TeamOutlined />
              <span>{t('menu.members')}</span>
            </>
          ),
        },
      ]}
    />
  );
};
